export default __webpack_public_path__ + "static/media/HDTX_The Invitation of GMS 2023.f08288d2.pdf";